import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Modal from "../../../../../components/Modal";
import messages from "../../../../../assets/locale/messages";
import {deleteServiceRequest} from '../../../../../store/Services/actions';

const DeleteManualAddedServiceModal = ({
    open,
    setOpen,
    selectedService,
    onSuccess
}) => {
    const dispatch = useDispatch();
    const lang = useSelector((state) => state.locale.lang);
    const { branches, shared } = messages[lang];

    const onConfirmDeleteSpecialty = async () => {
        await dispatch(
            deleteServiceRequest(
                {id:selectedService?.serviceId}, 
                    ()=>{
                        onSuccess();
                        setOpen(false);
                    }
                ));
    };

    return(
        <Modal
            open={open}
            handleClose={()=>setOpen(false)}
            title={<span className="fsize-26 fweight-400">{branches.addBranch.specialtiesAndServices.deleteManualServiceTitle}</span>}
            contentClass="mb-3 pb-2 text-primary"
            content={<p>{branches.addBranch.specialtiesAndServices.deleteManualServiceContent}</p> }
            confirmBtnTxt={shared.delete}
            cancelBtnTxt={shared.cancel}
            isContentText={false}
            handleConfirm={onConfirmDeleteSpecialty}
            handleCancel={()=>setOpen(false)}
            maxWidth="sm"
            actionsClass=" px-4"
            confirmBtnClass="btn-secondary fsize-14 text-white py-2 px-5"
            cancelBtnClass="fsize-14 py-2 text-secondary px-5 "
        />
    )
};

export default DeleteManualAddedServiceModal;